import {
  EnumTipoOnereDTOTipoVincolo,
  OnereWithDettaglioDTO,
} from '@framework/api-client';
import { t } from '@framework/i18n';
import { CurrencyRender } from '@framework/ui';
import { ColumnType, ColumnsType } from 'antd/es/table';
import { ColumnGroupType } from 'antd/lib/table';
import React from 'react';
import { BurdenPaymentStateTag } from './BurdenPaymentStateTag';

export const burdensColumnsBase = {
  tipoOnere: {
    title: t('burdens-columns.tipo', 'Tipo'),
    dataIndex: 'tipoOnere',
    key: 'tipoOnere',
    width: 200,
    render: (_, record) => {
      switch (record.tipoOnere?.tipoVincolo) {
        case EnumTipoOnereDTOTipoVincolo.FACOLTATIVO:
          return t('burdens-columns.facoltativo', 'Facoltativo');
        case EnumTipoOnereDTOTipoVincolo.OBBLIGATORIO:
          return t('burdens-columns.obbligatorio', 'Obbligatorio');
        case EnumTipoOnereDTOTipoVincolo.DA_PAGARE_DOPO_INVIO:
          return t(
            'burdens-columns.da-pagare-dopo-invio',
            "Da pagare dopo l'invio",
          );
        default:
          return null;
      }
    },
  },
  descrizione: {
    title: t('burdens-columns.descrizione', 'Descrizione'),
    dataIndex: 'descrizione',
    key: 'descrizione',
    render: (_, record) => record.descrizione,
  },
  valore: {
    title: t('burdens-columns.importo', 'Importo'),
    dataIndex: 'valore',
    key: 'valore',
    align: 'right',
    // TODO gestire editabilità degli importi
    // onCell: record => ({
    //   record,
    //   editable: record.tipoOnere?.flModificabile ?? false,
    //   dataIndex: record.tipoOnere?.flModificabile ? 'valore' : undefined,
    //   title: record.tipoOnere?.flModificabile ? 'Importo' : undefined,
    // }),
    render: (_, record) => <CurrencyRender value={record.valore} />,
  },
  stato: {
    title: t('burdens-columns.stato-onere', 'Stato Onere'),
    dataIndex: 'stato',
    key: 'stato',
    sortDataIndex: 'stato',
    render: (_, record) => <BurdenPaymentStateTag state={record.stato} />,
  },
} satisfies Record<
  string,
  ColumnGroupType<OnereWithDettaglioDTO> | ColumnType<OnereWithDettaglioDTO>
>;

export const burdensColumns: ColumnsType<OnereWithDettaglioDTO> = [
  burdensColumnsBase.descrizione,
  burdensColumnsBase.tipoOnere,
  burdensColumnsBase.stato,
  burdensColumnsBase.valore,
];

export const burdensColumnsMobile: ColumnsType<OnereWithDettaglioDTO> = [
  burdensColumnsBase.descrizione,
  burdensColumnsBase.valore,
];
